import { render, staticRenderFns } from "./setAddress.vue?vue&type=template&id=5cac48ac&scoped=true&"
import script from "./setAddress.vue?vue&type=script&lang=js&"
export * from "./setAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac48ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cac48ac')) {
      api.createRecord('5cac48ac', component.options)
    } else {
      api.reload('5cac48ac', component.options)
    }
    module.hot.accept("./setAddress.vue?vue&type=template&id=5cac48ac&scoped=true&", function () {
      api.rerender('5cac48ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/risk/dialogs/setAddress.vue"
export default component.exports